import fr from "@/lib/i18n/fr.json";
import ar from "@/lib/i18n/ar.json";
import hmn from "@/lib/i18n/hmn.json";

export const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "es", label: "Español", short: "ES" },
  { code: "vi", label: "Tiếng Việt", short: "VI" },
  { code: "fr", label: "Français", short: "FR" },
  { code: "ar", label: "العربية", short: "AR" },
  { code: "hmn", label: "Hmoob", short: "HMN" },
];

export const RTL_LANGS = ["ar"];

export const translations = {
  fr,
  ar,
  hmn,
  en: {
    "home.find": "Find",
    "home.lawyerSearch": "Find a North Carolina lawyer by name or firm…",
    "home.allAreas": "All practice areas",
    "nav.forms": "Forms Library",
    "nav.finder": "Form Finder",
    "nav.pricing": "Pricing",
    "nav.courtForms": "NC Courts Forms",
    "nav.sosForms": "NC SOS Forms",
    "nav.findAttorney": "Find an Attorney",
    "nav.forAttorneys": "For Attorneys",
    "nav.setCounty": "Set county",
    "nav.countyName": "{name} County",
    "nav.byCategory": "Browse by category",
    "nav.browseAll": "Browse all forms",
    "nav.mostUsed": "Most-used forms",
    "footer.byCounty": "Forms by County",
    "nav.workspace": "Workspace",
    "nav.collapse": "Collapse",
    "nav.dashboard": "Dashboard",
    "nav.admin": "Admin",
    "nav.profile": "My Info",
    "nav.signout": "Sign Out",
    "nav.login": "Log In",
    "nav.getAccess": "Get Access",
    "nav.matters": "My Cases",
    "matters.eyebrow": "Case Workspaces",
    "matters.title": "My Cases",
    "matters.subtitle": "Group all the forms for one legal matter — custody, divorce, eviction — into a single workspace with shared information that auto-fills every form.",
    "matters.newMatter": "New Case",
    "matters.name": "Case name",
    "matters.namePlaceholder": "e.g. Smith v. Smith — Custody",
    "matters.nameRequired": "Please enter a case name",
    "matters.type": "Case type",
    "matters.county": "County",
    "matters.countyPlaceholder": "Select a county",
    "matters.create": "Create Case",
    "matters.creating": "Creating…",
    "matters.created": "Case created",
    "matters.createFail": "Could not create case",
    "matters.loading": "Loading…",
    "matters.empty": "No cases yet. Create one to organize your forms.",
    "matters.forms": "{count} forms",
    "matter.notFound": "Case not found",
    "matter.back": "Back to my cases",
    "matter.allMatters": "All cases",
    "matter.delete": "Delete",
    "matter.deleteTitle": "Delete this case?",
    "matter.deleteDesc": "You can keep the forms in your saved list or delete them along with the case.",
    "matter.cancel": "Cancel",
    "matter.deleteKeepForms": "Delete case, keep forms",
    "matter.deleteAll": "Delete case + forms",
    "matter.deleted": "Case deleted",
    "matter.deleteFail": "Could not delete case",
    "matter.sharedEyebrow": "Shared case info",
    "matter.sharedDesc": "Enter these once. Every form you add to this case is pre-filled automatically.",
    "matter.saveShared": "Save shared info",
    "matter.saving": "Saving…",
    "matter.sharedSaved": "Shared info saved",
    "matter.saveFail": "Could not save",
    "matter.formsInCase": "Forms in this case ({count})",
    "matter.addForm": "Add form",
    "matter.addFormTitle": "Add a form to this case",
    "matter.searchForms": "Search by form number or title…",
    "matter.searching": "Searching…",
    "matter.noResults": "No forms found",
    "matter.add": "Add",
    "matter.adding": "Adding…",
    "matter.formAdded": "{number} added to case",
    "matter.addFail": "Could not add form",
    "matter.formRemoved": "Form removed from case",
    "matter.removeFail": "Could not remove form",
    "matter.formsEmpty": "No forms in this case yet.",
    "matter.openFill": "Open & fill",
    "matter.downloadFail": "Download failed",
    "matter.downloadPacket": "Download case packet",
    "matter.buildingPacket": "Building packet…",
    "matter.packetReady": "Case packet downloaded",
    "matter.packetFail": "Could not build case packet",
    "hero.eyebrow": "North Carolina Judicial Branch Forms",
    "hero.title1": "Fillable court forms,",
    "hero.title2": "done right.",
    "hero.subtitle": "Complete official North Carolina court forms online — or let AI fill them for you. The full {forms} form catalog, organized by category, fillable in your browser, and print-ready in seconds.",
    "hero.freeTrial": "Start free for 7 days.",
    "hero.findAI": "Find My Form with AI",
    "hero.browse": "Browse Forms",
    "hero.statForms": "Fillable Forms",
    "hero.statCategories": "Categories",
    "hero.statPrint": "Print Ready",
    "cta.eyebrow": "Get Started Today",
    "cta.title": "Complete your first form in minutes.",
    "cta.seePlans": "See Plans",
    "pricing.eyebrow": "Simple, Transparent Pricing",
    "pricing.title": "One plan. Every form.",
    "pricing.subtitle": "Browse for free. Upgrade to Pro to fill, save and print any North Carolina form.",
    "pricing.monthly": "Monthly",
    "pricing.annual": "Annual",
    "pricing.save20": "2 months free",
    "pricing.trial": "Every new account starts with a 7-day Pro trial — no card required.",
    "pricing.free": "Free",
    "pricing.freeSub": "Browse everything, forever.",
    "pricing.includedDefault": "Included by default",
    "pricing.recommended": "Recommended",
    "pricing.pro": "Pro",
    "pricing.perYear": "year",
    "pricing.perMonth": "month",
    "pricing.billedAnnual": "Billed annually — best value.",
    "pricing.billedMonthly": "Billed monthly. Cancel anytime.",
    "pricing.isPro": "You're a Pro member ✓",
    "pricing.redirecting": "Redirecting…",
    "pricing.upgrade": "Upgrade to Pro",
    "pricing.getPro": "Get Pro Access",
    "feat.browse": "Browse full forms catalog ({forms} forms)",
    "feat.details": "View form details & statutes",
    "feat.blankPdf": "Download blank official PDFs",
    "feat.fillOnline": "Fill forms online (side-by-side editor)",
    "feat.ai": "AI form completion + per-field guidance",
    "feat.download": "Download completed official PDFs (EN & ES)",
    "feat.save": "Save & edit your completed forms",
    "feat.print": "Print court-ready documents",
    "feat.unlimited": "Unlimited forms across all categories",
    "landing.catEyebrow": "Organized By Category",
    "landing.catTitle": "Find the exact form you need, grouped the way courts file them.",
    "landing.formsAvailable": "{count} forms available",
    "landing.badge": "Official NC Judicial Branch forms — filled by AI in seconds.",
    "landing.feat1t": "Complete with AI",
    "landing.feat1d": "Describe your situation in plain language and let AI map your details to the correct fields — with guidance on every entry.",
    "landing.feat2t": "{forms} official forms",
    "landing.feat2d": "The entire North Carolina Judicial Branch catalog, organized by category, searchable, and always the current version.",
    "landing.feat3t": "Fill, save & print",
    "landing.feat3d": "Complete the real court PDF online, download it filled (English or Spanish), save to your account, and print court-ready.",
    "catalog.eyebrow": "Forms Library · {count}+ forms",
    "catalog.title": "North Carolina Court Forms",
    "catalog.searchPlaceholder": "Search by form number, title or keyword…",
    "catalog.categories": "Categories",
    "catalog.all": "All",
    "catalog.results": "{count} forms",
    "catalog.pageOf": "Page {page} of {pages}",
    "catalog.loading": "Loading forms…",
    "catalog.noMatch": "No forms match your search.",
    "catalog.open": "Open",
    "catalog.prev": "Prev",
    "catalog.next": "Next",
    "dash.eyebrow": "Dashboard",
    "dash.welcome": "Welcome, {name}.",
    "dash.membership": "Membership",
    "dash.freeTrial": "Free Trial",
    "dash.proMember": "Pro Member",
    "dash.freePlan": "Free Plan",
    "dash.daysLeft": "{days} days left · full Pro access",
    "dash.fullAccessAdmin": "Full access (admin)",
    "dash.planActive": "{plan} plan active",
    "dash.annual": "Annual",
    "dash.monthly": "Monthly",
    "dash.upgradePrompt": "Upgrade to fill & print forms",
    "dash.upgradeNow": "Upgrade Now",
    "dash.upgrade": "Upgrade",
    "dash.opening": "Opening…",
    "dash.manageBilling": "Manage Billing",
    "dash.availableForms": "Available Forms",
    "dash.browseAll": "Browse all",
    "dash.forms": "{count} forms",
    "dash.savedTitle": "Your saved forms",
    "dash.viewAll": "View all",
    "dash.upgradeToSave": "Upgrade to Pro to fill and save forms to your account.",
    "dash.noSaved": "You haven't saved any forms yet.",
    "dash.startForm": "Start a form",
    "dash.filed": "Filed",
    "dash.updated": "Updated {date}",
    "dash.resumeTitle": "Continue where you left off",
    "dash.resumeCta": "Continue",
    "saved.eyebrow": "Your Documents",
    "saved.title": "Saved forms",
    "saved.filed": "{count} filed",
    "saved.notFiled": "{count} not filed",
    "saved.clearDrafts": "Clear drafts",
    "saved.clearTitle": "Clear all not-filed drafts?",
    "saved.clearDesc": "This permanently deletes your {count} not-filed drafts. Forms marked as filed are kept. This can't be undone.",
    "saved.cancel": "Cancel",
    "saved.clearConfirm": "Clear {count} drafts",
    "saved.proFeature": "Saving forms is a Pro feature.",
    "saved.upgradeToPro": "Upgrade to Pro",
    "saved.loading": "Loading…",
    "saved.noSaved": "No saved forms yet.",
    "saved.browseForms": "Browse forms",
    "saved.filedBadge": "Filed",
    "saved.notFiledBadge": "Not filed",
    "saved.updatedAt": "Updated {date}",
    "saved.markNotFiled": "Mark as not filed",
    "saved.markFiled": "Mark as filed",
    "saved.open": "Open",
    "saved.deleted": "Deleted",
    "saved.deleteFail": "Could not delete",
    "saved.downloadFail": "Could not download PDF",
    "saved.markedFiled": "Marked as filed with the court",
    "saved.markedNotFiled": "Marked as not filed",
    "saved.statusFail": "Could not update status",
    "saved.cleared": "Cleared {count} drafts",
    "saved.clearFail": "Could not clear drafts",
    "login.brandOverline": "STATE OF NORTH CAROLINA",
    "login.brandTitle": "Complete official court forms with confidence.",
    "login.brandDesc": "Fill, edit, save and print North Carolina Judicial Branch forms online — organized by category.",
    "login.brandTrust": "Trusted by self-represented litigants and paralegals statewide.",
    "login.backHome": "Back to home",
    "login.welcomeBack": "Welcome back",
    "login.createAccount": "Create your account",
    "login.loginSub": "Log in to access and complete forms.",
    "login.registerSub": "Sign up and your 7-day Pro trial starts instantly. No card required.",
    "login.continueGoogle": "Continue with Google",
    "login.googleAgreePre": "By continuing with Google you agree to our ",
    "login.terms": "Terms",
    "login.privacy": "Privacy Policy",
    "login.eula": "EULA",
    "login.or": "OR",
    "login.fullName": "Full Name",
    "login.namePlaceholder": "Jane Doe",
    "login.company": "Company / Law Firm",
    "login.optional": "(optional)",
    "login.companyPlaceholder": "Acme Law LLC",
    "login.email": "Email",
    "login.password": "Password",
    "login.pleaseWait": "Please wait…",
    "login.logIn": "Log In",
    "login.createBtn": "Create Account",
    "login.newHere": "New here? ",
    "login.haveAccount": "Already have an account? ",
    "login.createLink": "Create an account",
    "login.loginLink": "Log in",
    "login.agreePre": "I have read and agree to the ",
    "login.termsFull": "Terms & Conditions",
    "login.privacyFull": "Privacy Policy",
    "login.eulaFull": "End User Agreement",
    "login.andConn": "and ",
    "login.welcomeToast": "Welcome!",
    "login.authFailed": "Authentication failed",
    "login.acceptTerms": "Please accept the Terms, Privacy Policy, and End User Agreement",
    "finder.eyebrow": "AI Form Finder",
    "finder.title": "Not sure which form you need?",
    "finder.subtitle": "Describe your situation in plain language. Our AI reads the full North Carolina catalog and points you to the right forms — then fills them for you.",
    "finder.placeholder": "e.g. I need to change the amount of child support in an existing Wake County order because my income dropped.",
    "finder.listening": "● Listening… tap the square to stop.",
    "finder.transcribing": "Transcribing your voice…",
    "finder.hint": "AI reads {forms} NC forms · not legal advice",
    "finder.searching": "Searching…",
    "finder.findBtn": "Find My Forms",
    "finder.loginLink": "Log in",
    "finder.loginSuffix": " to use the finder — it's included with your free 7-day trial.",
    "finder.tryExample": "Try an example",
    "finder.ex1": "I need to modify my child support order because I lost my job.",
    "finder.ex2": "Someone is harassing me at my workplace and I want a no-contact order.",
    "finder.ex3": "I want to establish that I am the father of a child.",
    "finder.ex4": "I need to file a small claims case for unpaid rent.",
    "finder.noMatch": "No close matches. Try describing your situation differently, or browse by category.",
    "finder.browseLibrary": "Browse the library",
    "finder.recommended": "Recommended forms",
    "finder.strong": "Strong match",
    "finder.likely": "Likely match",
    "finder.possible": "Possible match",
    "finder.preview": "Preview",
    "finder.startDraft": "Start Draft",
    "finder.moreDetail": "Describe your situation in a bit more detail",
    "finder.noClose": "No close matches — try different words.",
    "finder.findFail": "Could not find forms",
    "finder.trialPrompt": "Start your free trial or upgrade to fill forms",
    "finder.draftFail": "Could not start draft",
    "detail.notFound": "Form not found",
    "detail.backLibrary": "Back to library",
    "detail.loading": "Loading…",
    "detail.formsLibrary": "Forms Library",
    "detail.statute": "Statute:",
    "detail.whatsOn": "What's on this form · {count} fields",
    "detail.moreFields": "+ {count} more fields",
    "detail.loginTitle": "Log in to fill this form",
    "detail.loginDesc": "Create a free account (7-day Pro trial) to complete forms online.",
    "detail.loginBtn": "Log In / Sign Up",
    "detail.readyTitle": "Ready to complete",
    "detail.readyDesc": "Fill this form field-by-field with a live preview, then print or download.",
    "detail.fillOnline": "Fill Online",
    "detail.downloadBlank": "Download Blank PDF",
    "detail.unlockTitle": "Unlock this form",
    "detail.unlockDesc": "Fill, save, AI-complete and download this form.",
    "detail.redirecting": "Redirecting…",
    "detail.unlockBtn": "Unlock this form — $3.95",
    "detail.tryPreview": "Try it free — fill & preview",
    "detail.or": "or",
    "detail.goPro": "Go Pro — unlimited forms",
    "detail.downloadBlankFree": "Download Blank PDF (free)",
    "detail.fileConjunction": "File in conjunction",
    "detail.oftenFiled": "Forms often filed with {number}",
    "detail.adding": "Adding…",
    "detail.addAll": "Add all to my forms",
    "detail.relatedDesc": "These forms are commonly completed alongside this one. Review each to see if your situation requires it.",
    "detail.goProToast": "Go Pro to save forms to your account",
    "detail.addedForms": "Added {count} forms to your account",
    "detail.checkoutFail": "Could not start checkout",
    "footer.tagline": "Fillable, editable and printable North Carolina Judicial Branch forms — organized by category and ready to complete online.",
    "footer.product": "Product",
    "footer.legalHead": "Legal",
    "footer.terms": "Terms & Conditions",
    "footer.privacy": "Privacy Policy",
    "footer.eula": "End User Agreement",
    "footer.disclaimer": "Not affiliated with the North Carolina Judicial Branch. Does not provide legal advice.",
    "footer.rights": "All rights reserved.",
  },
  es: {
    "home.find": "Buscar",
    "home.lawyerSearch": "Busque un abogado de Carolina del Norte por nombre o bufete…",
    "home.allAreas": "Todas las áreas de práctica",
    "nav.forms": "Biblioteca de formularios",
    "nav.finder": "Buscador de formularios",
    "nav.pricing": "Precios",
    "nav.courtForms": "Formularios judiciales de NC",
    "nav.sosForms": "Formularios SOS de NC",
    "nav.findAttorney": "Buscar abogado",
    "nav.forAttorneys": "Para abogados",
    "nav.setCounty": "Elegir condado",
    "nav.countyName": "Condado de {name}",
    "nav.byCategory": "Explorar por categoría",
    "nav.browseAll": "Ver todos los formularios",
    "nav.mostUsed": "Formularios más usados",
    "footer.byCounty": "Formularios por condado",
    "nav.workspace": "Espacio de trabajo",
    "nav.collapse": "Contraer",
    "nav.dashboard": "Panel",
    "nav.admin": "Administración",
    "nav.profile": "Mi información",
    "nav.signout": "Cerrar sesión",
    "nav.login": "Iniciar sesión",
    "nav.getAccess": "Obtener acceso",
    "nav.matters": "Mis casos",
    "matters.eyebrow": "Espacios de casos",
    "matters.title": "Mis casos",
    "matters.subtitle": "Agrupe todos los formularios de un asunto legal — custodia, divorcio, desalojo — en un solo espacio con información compartida que completa automáticamente cada formulario.",
    "matters.newMatter": "Nuevo caso",
    "matters.name": "Nombre del caso",
    "matters.namePlaceholder": "ej. Smith v. Smith — Custodia",
    "matters.nameRequired": "Ingrese un nombre de caso",
    "matters.type": "Tipo de caso",
    "matters.county": "Condado",
    "matters.countyPlaceholder": "Seleccione un condado",
    "matters.create": "Crear caso",
    "matters.creating": "Creando…",
    "matters.created": "Caso creado",
    "matters.createFail": "No se pudo crear el caso",
    "matters.loading": "Cargando…",
    "matters.empty": "Aún no hay casos. Cree uno para organizar sus formularios.",
    "matters.forms": "{count} formularios",
    "matter.notFound": "Caso no encontrado",
    "matter.back": "Volver a mis casos",
    "matter.allMatters": "Todos los casos",
    "matter.delete": "Eliminar",
    "matter.deleteTitle": "¿Eliminar este caso?",
    "matter.deleteDesc": "Puede conservar los formularios en su lista guardada o eliminarlos junto con el caso.",
    "matter.cancel": "Cancelar",
    "matter.deleteKeepForms": "Eliminar caso, conservar formularios",
    "matter.deleteAll": "Eliminar caso + formularios",
    "matter.deleted": "Caso eliminado",
    "matter.deleteFail": "No se pudo eliminar el caso",
    "matter.sharedEyebrow": "Información compartida",
    "matter.sharedDesc": "Ingrésela una vez. Cada formulario que agregue a este caso se completa automáticamente.",
    "matter.saveShared": "Guardar información compartida",
    "matter.saving": "Guardando…",
    "matter.sharedSaved": "Información compartida guardada",
    "matter.saveFail": "No se pudo guardar",
    "matter.formsInCase": "Formularios en este caso ({count})",
    "matter.addForm": "Agregar formulario",
    "matter.addFormTitle": "Agregar un formulario a este caso",
    "matter.searchForms": "Buscar por número o título…",
    "matter.searching": "Buscando…",
    "matter.noResults": "No se encontraron formularios",
    "matter.add": "Agregar",
    "matter.adding": "Agregando…",
    "matter.formAdded": "{number} agregado al caso",
    "matter.addFail": "No se pudo agregar el formulario",
    "matter.formRemoved": "Formulario eliminado del caso",
    "matter.removeFail": "No se pudo eliminar el formulario",
    "matter.formsEmpty": "Aún no hay formularios en este caso.",
    "matter.openFill": "Abrir y completar",
    "matter.downloadFail": "Error al descargar",
    "matter.downloadPacket": "Descargar paquete del caso",
    "matter.buildingPacket": "Generando paquete…",
    "matter.packetReady": "Paquete del caso descargado",
    "matter.packetFail": "No se pudo generar el paquete",
    "hero.eyebrow": "Formularios de la Rama Judicial de Carolina del Norte",
    "hero.title1": "Formularios judiciales rellenables,",
    "hero.title2": "bien hechos.",
    "hero.subtitle": "Complete formularios judiciales oficiales de Carolina del Norte en línea, o deje que la IA los complete por usted. El catálogo completo de {forms} formularios, organizados por categoría, rellenables en su navegador y listos para imprimir en segundos.",
    "hero.freeTrial": "Comience gratis por 7 días.",
    "hero.findAI": "Buscar mi formulario con IA",
    "hero.browse": "Ver formularios",
    "hero.statForms": "Formularios rellenables",
    "hero.statCategories": "Categorías",
    "hero.statPrint": "Listo para imprimir",
    "cta.eyebrow": "Comience hoy",
    "cta.title": "Complete su primer formulario en minutos.",
    "cta.seePlans": "Ver planes",
    "pricing.eyebrow": "Precios simples y transparentes",
    "pricing.title": "Un plan. Todos los formularios.",
    "pricing.subtitle": "Explore gratis. Actualice a Pro para llenar, guardar e imprimir cualquier formulario de Carolina del Norte.",
    "pricing.monthly": "Mensual",
    "pricing.annual": "Anual",
    "pricing.save20": "2 meses gratis",
    "pricing.trial": "Cada cuenta nueva comienza con una prueba Pro de 7 días — sin tarjeta.",
    "pricing.free": "Gratis",
    "pricing.freeSub": "Explore todo, para siempre.",
    "pricing.includedDefault": "Incluido por defecto",
    "pricing.recommended": "Recomendado",
    "pricing.pro": "Pro",
    "pricing.perYear": "año",
    "pricing.perMonth": "mes",
    "pricing.billedAnnual": "Facturado anualmente — mejor valor.",
    "pricing.billedMonthly": "Facturado mensualmente. Cancele cuando quiera.",
    "pricing.isPro": "Usted es miembro Pro ✓",
    "pricing.redirecting": "Redirigiendo…",
    "pricing.upgrade": "Actualizar a Pro",
    "pricing.getPro": "Obtener acceso Pro",
    "feat.browse": "Explore el catálogo completo ({forms} formularios)",
    "feat.details": "Ver detalles del formulario y estatutos",
    "feat.blankPdf": "Descargar PDF oficiales en blanco",
    "feat.fillOnline": "Llenar formularios en línea (editor lado a lado)",
    "feat.ai": "Autocompletado con IA + guía por campo",
    "feat.download": "Descargar PDF oficiales completados (EN y ES)",
    "feat.save": "Guardar y editar sus formularios completados",
    "feat.print": "Imprimir documentos listos para el tribunal",
    "feat.unlimited": "Formularios ilimitados en todas las categorías",
    "landing.catEyebrow": "Organizado por categoría",
    "landing.catTitle": "Encuentre el formulario exacto que necesita, agrupado como los tribunales los archivan.",
    "landing.formsAvailable": "{count} formularios disponibles",
    "landing.badge": "Formularios oficiales de la Rama Judicial de NC — completados por IA en segundos.",
    "landing.feat1t": "Complete con IA",
    "landing.feat1d": "Describa su situación en lenguaje sencillo y deje que la IA asigne sus datos a los campos correctos, con orientación en cada entrada.",
    "landing.feat2t": "{forms} formularios oficiales",
    "landing.feat2d": "Todo el catálogo de la Rama Judicial de Carolina del Norte, organizado por categoría, con búsqueda y siempre en la versión actual.",
    "landing.feat3t": "Llene, guarde e imprima",
    "landing.feat3d": "Complete el PDF judicial real en línea, descárguelo lleno (en inglés o español), guárdelo en su cuenta e imprima listo para el tribunal.",
    "catalog.eyebrow": "Biblioteca de formularios · más de {count} formularios",
    "catalog.title": "Formularios judiciales de Carolina del Norte",
    "catalog.searchPlaceholder": "Busque por número de formulario, título o palabra clave…",
    "catalog.categories": "Categorías",
    "catalog.all": "Todos",
    "catalog.results": "{count} formularios",
    "catalog.pageOf": "Página {page} de {pages}",
    "catalog.loading": "Cargando formularios…",
    "catalog.noMatch": "Ningún formulario coincide con su búsqueda.",
    "catalog.open": "Abrir",
    "catalog.prev": "Anterior",
    "catalog.next": "Siguiente",
    "dash.eyebrow": "Panel",
    "dash.welcome": "Bienvenido, {name}.",
    "dash.membership": "Membresía",
    "dash.freeTrial": "Prueba gratuita",
    "dash.proMember": "Miembro Pro",
    "dash.freePlan": "Plan gratuito",
    "dash.daysLeft": "{days} días restantes · acceso Pro completo",
    "dash.fullAccessAdmin": "Acceso total (administrador)",
    "dash.planActive": "Plan {plan} activo",
    "dash.annual": "Anual",
    "dash.monthly": "Mensual",
    "dash.upgradePrompt": "Actualice para llenar e imprimir formularios",
    "dash.upgradeNow": "Actualizar ahora",
    "dash.upgrade": "Actualizar",
    "dash.opening": "Abriendo…",
    "dash.manageBilling": "Administrar facturación",
    "dash.availableForms": "Formularios disponibles",
    "dash.browseAll": "Ver todos",
    "dash.forms": "{count} formularios",
    "dash.savedTitle": "Sus formularios guardados",
    "dash.viewAll": "Ver todos",
    "dash.upgradeToSave": "Actualice a Pro para llenar y guardar formularios en su cuenta.",
    "dash.noSaved": "Aún no ha guardado ningún formulario.",
    "dash.startForm": "Comenzar un formulario",
    "dash.filed": "Presentado",
    "dash.updated": "Actualizado {date}",
    "dash.resumeTitle": "Continúe donde lo dejó",
    "dash.resumeCta": "Continuar",
    "saved.eyebrow": "Sus documentos",
    "saved.title": "Formularios guardados",
    "saved.filed": "{count} presentados",
    "saved.notFiled": "{count} no presentados",
    "saved.clearDrafts": "Borrar borradores",
    "saved.clearTitle": "¿Borrar todos los borradores no presentados?",
    "saved.clearDesc": "Esto elimina permanentemente sus {count} borradores no presentados. Los formularios marcados como presentados se conservan. Esto no se puede deshacer.",
    "saved.cancel": "Cancelar",
    "saved.clearConfirm": "Borrar {count} borradores",
    "saved.proFeature": "Guardar formularios es una función Pro.",
    "saved.upgradeToPro": "Actualizar a Pro",
    "saved.loading": "Cargando…",
    "saved.noSaved": "Aún no hay formularios guardados.",
    "saved.browseForms": "Ver formularios",
    "saved.filedBadge": "Presentado",
    "saved.notFiledBadge": "No presentado",
    "saved.updatedAt": "Actualizado {date}",
    "saved.markNotFiled": "Marcar como no presentado",
    "saved.markFiled": "Marcar como presentado",
    "saved.open": "Abrir",
    "saved.deleted": "Eliminado",
    "saved.deleteFail": "No se pudo eliminar",
    "saved.downloadFail": "No se pudo descargar el PDF",
    "saved.markedFiled": "Marcado como presentado ante el tribunal",
    "saved.markedNotFiled": "Marcado como no presentado",
    "saved.statusFail": "No se pudo actualizar el estado",
    "saved.cleared": "Se borraron {count} borradores",
    "saved.clearFail": "No se pudieron borrar los borradores",
    "login.brandOverline": "ESTADO DE CAROLINA DEL NORTE",
    "login.brandTitle": "Complete formularios judiciales oficiales con confianza.",
    "login.brandDesc": "Llene, edite, guarde e imprima formularios de la Rama Judicial de Carolina del Norte en línea, organizados por categoría.",
    "login.brandTrust": "Con la confianza de litigantes autorepresentados y asistentes legales en todo el estado.",
    "login.backHome": "Volver al inicio",
    "login.welcomeBack": "Bienvenido de nuevo",
    "login.createAccount": "Cree su cuenta",
    "login.loginSub": "Inicie sesión para acceder y completar formularios.",
    "login.registerSub": "Regístrese y su prueba Pro de 7 días comienza al instante. No se requiere tarjeta.",
    "login.continueGoogle": "Continuar con Google",
    "login.googleAgreePre": "Al continuar con Google, acepta nuestros ",
    "login.terms": "Términos",
    "login.privacy": "Política de privacidad",
    "login.eula": "EULA",
    "login.or": "O",
    "login.fullName": "Nombre completo",
    "login.namePlaceholder": "Juana Pérez",
    "login.company": "Empresa / Bufete",
    "login.optional": "(opcional)",
    "login.companyPlaceholder": "Bufete Acme S.C.",
    "login.email": "Correo electrónico",
    "login.password": "Contraseña",
    "login.pleaseWait": "Espere…",
    "login.logIn": "Iniciar sesión",
    "login.createBtn": "Crear cuenta",
    "login.newHere": "¿Nuevo aquí? ",
    "login.haveAccount": "¿Ya tiene una cuenta? ",
    "login.createLink": "Cree una cuenta",
    "login.loginLink": "Iniciar sesión",
    "login.agreePre": "He leído y acepto los ",
    "login.termsFull": "Términos y condiciones",
    "login.privacyFull": "Política de privacidad",
    "login.eulaFull": "Acuerdo de usuario final",
    "login.andConn": "y ",
    "login.welcomeToast": "¡Bienvenido!",
    "login.authFailed": "Error de autenticación",
    "login.acceptTerms": "Acepte los Términos, la Política de privacidad y el Acuerdo de usuario final",
    "finder.eyebrow": "Buscador de formularios con IA",
    "finder.title": "¿No sabe qué formulario necesita?",
    "finder.subtitle": "Describa su situación en lenguaje sencillo. Nuestra IA lee todo el catálogo de Carolina del Norte y le indica los formularios correctos, y luego los completa por usted.",
    "finder.placeholder": "p. ej. Necesito cambiar el monto de la manutención infantil en una orden existente del condado de Wake porque bajaron mis ingresos.",
    "finder.listening": "● Escuchando… toque el cuadrado para detener.",
    "finder.transcribing": "Transcribiendo su voz…",
    "finder.hint": "La IA lee {forms} formularios de NC · no es asesoría legal",
    "finder.searching": "Buscando…",
    "finder.findBtn": "Buscar mis formularios",
    "finder.loginLink": "Inicie sesión",
    "finder.loginSuffix": " para usar el buscador — está incluido en su prueba gratuita de 7 días.",
    "finder.tryExample": "Pruebe un ejemplo",
    "finder.ex1": "Necesito modificar mi orden de manutención infantil porque perdí mi trabajo.",
    "finder.ex2": "Alguien me está acosando en mi trabajo y quiero una orden de no contacto.",
    "finder.ex3": "Quiero establecer que soy el padre de un niño.",
    "finder.ex4": "Necesito presentar un caso de reclamos menores por alquiler no pagado.",
    "finder.noMatch": "No hay coincidencias cercanas. Intente describir su situación de otra manera o busque por categoría.",
    "finder.browseLibrary": "Explorar la biblioteca",
    "finder.recommended": "Formularios recomendados",
    "finder.strong": "Coincidencia fuerte",
    "finder.likely": "Coincidencia probable",
    "finder.possible": "Posible coincidencia",
    "finder.preview": "Vista previa",
    "finder.startDraft": "Comenzar borrador",
    "finder.moreDetail": "Describa su situación con un poco más de detalle",
    "finder.noClose": "No hay coincidencias cercanas — pruebe con otras palabras.",
    "finder.findFail": "No se pudieron encontrar formularios",
    "finder.trialPrompt": "Comience su prueba gratuita o actualice para llenar formularios",
    "finder.draftFail": "No se pudo comenzar el borrador",
    "detail.notFound": "Formulario no encontrado",
    "detail.backLibrary": "Volver a la biblioteca",
    "detail.loading": "Cargando…",
    "detail.formsLibrary": "Biblioteca de formularios",
    "detail.statute": "Estatuto:",
    "detail.whatsOn": "Qué contiene este formulario · {count} campos",
    "detail.moreFields": "+ {count} campos más",
    "detail.loginTitle": "Inicie sesión para llenar este formulario",
    "detail.loginDesc": "Cree una cuenta gratuita (prueba Pro de 7 días) para completar formularios en línea.",
    "detail.loginBtn": "Iniciar sesión / Registrarse",
    "detail.readyTitle": "Listo para completar",
    "detail.readyDesc": "Llene este formulario campo por campo con vista previa en vivo, luego imprima o descargue.",
    "detail.fillOnline": "Llenar en línea",
    "detail.downloadBlank": "Descargar PDF en blanco",
    "detail.unlockTitle": "Desbloquee este formulario",
    "detail.unlockDesc": "Llene, guarde, complete con IA y descargue este formulario.",
    "detail.redirecting": "Redirigiendo…",
    "detail.unlockBtn": "Desbloquee este formulario — $3.95",
    "detail.tryPreview": "Pruébelo gratis — llenar y previsualizar",
    "detail.or": "o",
    "detail.goPro": "Hágase Pro — formularios ilimitados",
    "detail.downloadBlankFree": "Descargar PDF en blanco (gratis)",
    "detail.fileConjunction": "Presentar en conjunto",
    "detail.oftenFiled": "Formularios que suelen presentarse con {number}",
    "detail.adding": "Agregando…",
    "detail.addAll": "Agregar todos a mis formularios",
    "detail.relatedDesc": "Estos formularios suelen completarse junto con este. Revise cada uno para ver si su situación lo requiere.",
    "detail.goProToast": "Hágase Pro para guardar formularios en su cuenta",
    "detail.addedForms": "Se agregaron {count} formularios a su cuenta",
    "detail.checkoutFail": "No se pudo iniciar el pago",
    "footer.tagline": "Formularios de la Rama Judicial de Carolina del Norte rellenables, editables e imprimibles — organizados por categoría y listos para completar en línea.",
    "footer.product": "Producto",
    "footer.legalHead": "Legal",
    "footer.terms": "Términos y condiciones",
    "footer.privacy": "Política de privacidad",
    "footer.eula": "Acuerdo de usuario final",
    "footer.disclaimer": "No afiliado con la Rama Judicial de Carolina del Norte. No brinda asesoría legal.",
    "footer.rights": "Todos los derechos reservados.",
  },
  vi: {
    "home.find": "Tìm",
    "home.lawyerSearch": "Tìm luật sư Bắc Carolina theo tên hoặc văn phòng…",
    "home.allAreas": "Tất cả lĩnh vực hành nghề",
    "nav.forms": "Thư viện biểu mẫu",
    "nav.finder": "Tìm biểu mẫu",
    "nav.pricing": "Bảng giá",
    "nav.courtForms": "Biểu mẫu Tòa án NC",
    "nav.sosForms": "Biểu mẫu SOS NC",
    "nav.findAttorney": "Tìm luật sư",
    "nav.forAttorneys": "Dành cho luật sư",
    "nav.setCounty": "Chọn quận",
    "nav.countyName": "Quận {name}",
    "nav.byCategory": "Duyệt theo danh mục",
    "nav.browseAll": "Xem tất cả biểu mẫu",
    "nav.mostUsed": "Biểu mẫu dùng nhiều nhất",
    "footer.byCounty": "Biểu mẫu theo quận",
    "nav.workspace": "Không gian làm việc",
    "nav.collapse": "Thu gọn",
    "nav.dashboard": "Bảng điều khiển",
    "nav.admin": "Quản trị",
    "nav.profile": "Thông tin của tôi",
    "nav.signout": "Đăng xuất",
    "nav.login": "Đăng nhập",
    "nav.getAccess": "Bắt đầu",
    "nav.matters": "Vụ việc của tôi",
    "matters.eyebrow": "Không gian vụ việc",
    "matters.title": "Vụ việc của tôi",
    "matters.subtitle": "Nhóm tất cả biểu mẫu cho một vụ việc pháp lý — quyền nuôi con, ly hôn, trục xuất — vào một không gian với thông tin dùng chung tự động điền vào mọi biểu mẫu.",
    "matters.newMatter": "Vụ việc mới",
    "matters.name": "Tên vụ việc",
    "matters.namePlaceholder": "vd. Smith v. Smith — Quyền nuôi con",
    "matters.nameRequired": "Vui lòng nhập tên vụ việc",
    "matters.type": "Loại vụ việc",
    "matters.county": "Quận/Hạt",
    "matters.countyPlaceholder": "Chọn quận/hạt",
    "matters.create": "Tạo vụ việc",
    "matters.creating": "Đang tạo…",
    "matters.created": "Đã tạo vụ việc",
    "matters.createFail": "Không thể tạo vụ việc",
    "matters.loading": "Đang tải…",
    "matters.empty": "Chưa có vụ việc nào. Tạo một vụ để sắp xếp biểu mẫu.",
    "matters.forms": "{count} biểu mẫu",
    "matter.notFound": "Không tìm thấy vụ việc",
    "matter.back": "Quay lại vụ việc của tôi",
    "matter.allMatters": "Tất cả vụ việc",
    "matter.delete": "Xóa",
    "matter.deleteTitle": "Xóa vụ việc này?",
    "matter.deleteDesc": "Bạn có thể giữ biểu mẫu trong danh sách đã lưu hoặc xóa cùng với vụ việc.",
    "matter.cancel": "Hủy",
    "matter.deleteKeepForms": "Xóa vụ việc, giữ biểu mẫu",
    "matter.deleteAll": "Xóa vụ việc + biểu mẫu",
    "matter.deleted": "Đã xóa vụ việc",
    "matter.deleteFail": "Không thể xóa vụ việc",
    "matter.sharedEyebrow": "Thông tin dùng chung",
    "matter.sharedDesc": "Nhập một lần. Mọi biểu mẫu bạn thêm vào vụ việc này sẽ được điền sẵn.",
    "matter.saveShared": "Lưu thông tin dùng chung",
    "matter.saving": "Đang lưu…",
    "matter.sharedSaved": "Đã lưu thông tin dùng chung",
    "matter.saveFail": "Không thể lưu",
    "matter.formsInCase": "Biểu mẫu trong vụ việc này ({count})",
    "matter.addForm": "Thêm biểu mẫu",
    "matter.addFormTitle": "Thêm biểu mẫu vào vụ việc này",
    "matter.searchForms": "Tìm theo số hoặc tiêu đề…",
    "matter.searching": "Đang tìm…",
    "matter.noResults": "Không tìm thấy biểu mẫu",
    "matter.add": "Thêm",
    "matter.adding": "Đang thêm…",
    "matter.formAdded": "Đã thêm {number} vào vụ việc",
    "matter.addFail": "Không thể thêm biểu mẫu",
    "matter.formRemoved": "Đã xóa biểu mẫu khỏi vụ việc",
    "matter.removeFail": "Không thể xóa biểu mẫu",
    "matter.formsEmpty": "Chưa có biểu mẫu nào trong vụ việc này.",
    "matter.openFill": "Mở và điền",
    "matter.downloadFail": "Tải xuống thất bại",
    "matter.downloadPacket": "Tải gói hồ sơ vụ việc",
    "matter.buildingPacket": "Đang tạo gói…",
    "matter.packetReady": "Đã tải gói hồ sơ vụ việc",
    "matter.packetFail": "Không thể tạo gói hồ sơ",
    "hero.eyebrow": "Biểu mẫu Ngành Tư pháp Bắc Carolina",
    "hero.title1": "Biểu mẫu tòa án điền được,",
    "hero.title2": "thực hiện đúng cách.",
    "hero.subtitle": "Hoàn thành các biểu mẫu tòa án chính thức của Bắc Carolina trực tuyến — hoặc để AI điền giúp bạn. Toàn bộ danh mục {forms} biểu mẫu, sắp xếp theo danh mục, điền được ngay trên trình duyệt và sẵn sàng in trong vài giây.",
    "hero.freeTrial": "Dùng thử miễn phí 7 ngày.",
    "hero.findAI": "Tìm biểu mẫu bằng AI",
    "hero.browse": "Xem biểu mẫu",
    "hero.statForms": "Biểu mẫu điền được",
    "hero.statCategories": "Danh mục",
    "hero.statPrint": "Sẵn sàng in",
    "cta.eyebrow": "Bắt đầu hôm nay",
    "cta.title": "Hoàn thành biểu mẫu đầu tiên của bạn trong vài phút.",
    "cta.seePlans": "Xem gói",
    "pricing.eyebrow": "Giá đơn giản, minh bạch",
    "pricing.title": "Một gói. Mọi biểu mẫu.",
    "pricing.subtitle": "Duyệt miễn phí. Nâng cấp lên Pro để điền, lưu và in bất kỳ biểu mẫu nào của Bắc Carolina.",
    "pricing.monthly": "Hàng tháng",
    "pricing.annual": "Hàng năm",
    "pricing.save20": "miễn phí 2 tháng",
    "pricing.trial": "Mỗi tài khoản mới bắt đầu với bản dùng thử Pro 7 ngày — không cần thẻ.",
    "pricing.free": "Miễn phí",
    "pricing.freeSub": "Duyệt mọi thứ, mãi mãi.",
    "pricing.includedDefault": "Được bao gồm mặc định",
    "pricing.recommended": "Được đề xuất",
    "pricing.pro": "Pro",
    "pricing.perYear": "năm",
    "pricing.perMonth": "tháng",
    "pricing.billedAnnual": "Thanh toán hàng năm — giá trị tốt nhất.",
    "pricing.billedMonthly": "Thanh toán hàng tháng. Hủy bất cứ lúc nào.",
    "pricing.isPro": "Bạn là thành viên Pro ✓",
    "pricing.redirecting": "Đang chuyển hướng…",
    "pricing.upgrade": "Nâng cấp lên Pro",
    "pricing.getPro": "Nhận quyền truy cập Pro",
    "feat.browse": "Duyệt toàn bộ danh mục biểu mẫu ({forms} biểu mẫu)",
    "feat.details": "Xem chi tiết biểu mẫu & điều luật",
    "feat.blankPdf": "Tải PDF chính thức trống",
    "feat.fillOnline": "Điền biểu mẫu trực tuyến (trình chỉnh sửa song song)",
    "feat.ai": "Điền biểu mẫu bằng AI + hướng dẫn từng trường",
    "feat.download": "Tải PDF chính thức đã hoàn thành (EN & ES)",
    "feat.save": "Lưu & chỉnh sửa biểu mẫu đã hoàn thành",
    "feat.print": "In tài liệu sẵn sàng cho tòa án",
    "feat.unlimited": "Biểu mẫu không giới hạn trên tất cả danh mục",
    "landing.catEyebrow": "Sắp xếp theo danh mục",
    "landing.catTitle": "Tìm đúng biểu mẫu bạn cần, được nhóm theo cách tòa án lưu trữ.",
    "landing.formsAvailable": "{count} biểu mẫu có sẵn",
    "landing.badge": "Biểu mẫu chính thức của Ngành Tư pháp NC — được AI điền trong vài giây.",
    "landing.feat1t": "Điền bằng AI",
    "landing.feat1d": "Mô tả tình huống của bạn bằng ngôn ngữ đơn giản và để AI ánh xạ thông tin của bạn vào đúng các trường — kèm hướng dẫn cho từng mục.",
    "landing.feat2t": "{forms} biểu mẫu chính thức",
    "landing.feat2d": "Toàn bộ danh mục của Ngành Tư pháp Bắc Carolina, sắp xếp theo danh mục, có thể tìm kiếm và luôn là phiên bản mới nhất.",
    "landing.feat3t": "Điền, lưu & in",
    "landing.feat3d": "Hoàn thành PDF tòa án thật trực tuyến, tải xuống bản đã điền (tiếng Anh hoặc tiếng Tây Ban Nha), lưu vào tài khoản và in sẵn sàng cho tòa.",
    "catalog.eyebrow": "Thư viện biểu mẫu · hơn {count} biểu mẫu",
    "catalog.title": "Biểu mẫu tòa án Bắc Carolina",
    "catalog.searchPlaceholder": "Tìm theo số biểu mẫu, tiêu đề hoặc từ khóa…",
    "catalog.categories": "Danh mục",
    "catalog.all": "Tất cả",
    "catalog.results": "{count} biểu mẫu",
    "catalog.pageOf": "Trang {page} / {pages}",
    "catalog.loading": "Đang tải biểu mẫu…",
    "catalog.noMatch": "Không có biểu mẫu nào khớp với tìm kiếm của bạn.",
    "catalog.open": "Mở",
    "catalog.prev": "Trước",
    "catalog.next": "Sau",
    "dash.eyebrow": "Bảng điều khiển",
    "dash.welcome": "Chào mừng, {name}.",
    "dash.membership": "Tư cách thành viên",
    "dash.freeTrial": "Dùng thử miễn phí",
    "dash.proMember": "Thành viên Pro",
    "dash.freePlan": "Gói miễn phí",
    "dash.daysLeft": "còn {days} ngày · toàn quyền Pro",
    "dash.fullAccessAdmin": "Toàn quyền truy cập (quản trị)",
    "dash.planActive": "Gói {plan} đang hoạt động",
    "dash.annual": "Hàng năm",
    "dash.monthly": "Hàng tháng",
    "dash.upgradePrompt": "Nâng cấp để điền & in biểu mẫu",
    "dash.upgradeNow": "Nâng cấp ngay",
    "dash.upgrade": "Nâng cấp",
    "dash.opening": "Đang mở…",
    "dash.manageBilling": "Quản lý thanh toán",
    "dash.availableForms": "Biểu mẫu có sẵn",
    "dash.browseAll": "Xem tất cả",
    "dash.forms": "{count} biểu mẫu",
    "dash.savedTitle": "Biểu mẫu đã lưu của bạn",
    "dash.viewAll": "Xem tất cả",
    "dash.upgradeToSave": "Nâng cấp lên Pro để điền và lưu biểu mẫu vào tài khoản của bạn.",
    "dash.noSaved": "Bạn chưa lưu biểu mẫu nào.",
    "dash.startForm": "Bắt đầu một biểu mẫu",
    "dash.filed": "Đã nộp",
    "dash.updated": "Đã cập nhật {date}",
    "dash.resumeTitle": "Tiếp tục từ chỗ bạn đã dừng",
    "dash.resumeCta": "Tiếp tục",
    "saved.eyebrow": "Tài liệu của bạn",
    "saved.title": "Biểu mẫu đã lưu",
    "saved.filed": "{count} đã nộp",
    "saved.notFiled": "{count} chưa nộp",
    "saved.clearDrafts": "Xóa bản nháp",
    "saved.clearTitle": "Xóa tất cả bản nháp chưa nộp?",
    "saved.clearDesc": "Thao tác này xóa vĩnh viễn {count} bản nháp chưa nộp của bạn. Các biểu mẫu được đánh dấu đã nộp sẽ được giữ lại. Không thể hoàn tác.",
    "saved.cancel": "Hủy",
    "saved.clearConfirm": "Xóa {count} bản nháp",
    "saved.proFeature": "Lưu biểu mẫu là tính năng Pro.",
    "saved.upgradeToPro": "Nâng cấp lên Pro",
    "saved.loading": "Đang tải…",
    "saved.noSaved": "Chưa có biểu mẫu nào được lưu.",
    "saved.browseForms": "Xem biểu mẫu",
    "saved.filedBadge": "Đã nộp",
    "saved.notFiledBadge": "Chưa nộp",
    "saved.updatedAt": "Đã cập nhật {date}",
    "saved.markNotFiled": "Đánh dấu chưa nộp",
    "saved.markFiled": "Đánh dấu đã nộp",
    "saved.open": "Mở",
    "saved.deleted": "Đã xóa",
    "saved.deleteFail": "Không thể xóa",
    "saved.downloadFail": "Không thể tải PDF",
    "saved.markedFiled": "Đã đánh dấu đã nộp cho tòa án",
    "saved.markedNotFiled": "Đã đánh dấu chưa nộp",
    "saved.statusFail": "Không thể cập nhật trạng thái",
    "saved.cleared": "Đã xóa {count} bản nháp",
    "saved.clearFail": "Không thể xóa bản nháp",
    "login.brandOverline": "TIỂU BANG BẮC CAROLINA",
    "login.brandTitle": "Hoàn thành biểu mẫu tòa án chính thức một cách tự tin.",
    "login.brandDesc": "Điền, chỉnh sửa, lưu và in các biểu mẫu của Ngành Tư pháp Bắc Carolina trực tuyến — sắp xếp theo danh mục.",
    "login.brandTrust": "Được tin dùng bởi các đương sự tự đại diện và trợ lý pháp lý trên toàn tiểu bang.",
    "login.backHome": "Về trang chủ",
    "login.welcomeBack": "Chào mừng trở lại",
    "login.createAccount": "Tạo tài khoản của bạn",
    "login.loginSub": "Đăng nhập để truy cập và hoàn thành biểu mẫu.",
    "login.registerSub": "Đăng ký và bản dùng thử Pro 7 ngày của bạn bắt đầu ngay lập tức. Không cần thẻ.",
    "login.continueGoogle": "Tiếp tục với Google",
    "login.googleAgreePre": "Bằng cách tiếp tục với Google, bạn đồng ý với ",
    "login.terms": "Điều khoản",
    "login.privacy": "Chính sách bảo mật",
    "login.eula": "EULA",
    "login.or": "HOẶC",
    "login.fullName": "Họ và tên",
    "login.namePlaceholder": "Nguyễn Văn A",
    "login.company": "Công ty / Văn phòng luật",
    "login.optional": "(tùy chọn)",
    "login.companyPlaceholder": "Công ty Luật Acme",
    "login.email": "Email",
    "login.password": "Mật khẩu",
    "login.pleaseWait": "Vui lòng đợi…",
    "login.logIn": "Đăng nhập",
    "login.createBtn": "Tạo tài khoản",
    "login.newHere": "Mới ở đây? ",
    "login.haveAccount": "Đã có tài khoản? ",
    "login.createLink": "Tạo tài khoản",
    "login.loginLink": "Đăng nhập",
    "login.agreePre": "Tôi đã đọc và đồng ý với ",
    "login.termsFull": "Điều khoản & Điều kiện",
    "login.privacyFull": "Chính sách bảo mật",
    "login.eulaFull": "Thỏa thuận người dùng cuối",
    "login.andConn": "và ",
    "login.welcomeToast": "Chào mừng!",
    "login.authFailed": "Xác thực thất bại",
    "login.acceptTerms": "Vui lòng chấp nhận Điều khoản, Chính sách bảo mật và Thỏa thuận người dùng cuối",
    "finder.eyebrow": "Trình tìm biểu mẫu AI",
    "finder.title": "Không chắc bạn cần biểu mẫu nào?",
    "finder.subtitle": "Mô tả tình huống của bạn bằng ngôn ngữ đơn giản. AI của chúng tôi đọc toàn bộ danh mục Bắc Carolina và chỉ cho bạn đúng biểu mẫu — rồi điền giúp bạn.",
    "finder.placeholder": "vd. Tôi cần thay đổi mức cấp dưỡng con trong một lệnh hiện có của quận Wake vì thu nhập của tôi giảm.",
    "finder.listening": "● Đang nghe… nhấn hình vuông để dừng.",
    "finder.transcribing": "Đang chuyển giọng nói của bạn…",
    "finder.hint": "AI đọc {forms} biểu mẫu NC · không phải tư vấn pháp lý",
    "finder.searching": "Đang tìm…",
    "finder.findBtn": "Tìm biểu mẫu của tôi",
    "finder.loginLink": "Đăng nhập",
    "finder.loginSuffix": " để dùng trình tìm kiếm — đã bao gồm trong bản dùng thử miễn phí 7 ngày của bạn.",
    "finder.tryExample": "Thử một ví dụ",
    "finder.ex1": "Tôi cần sửa đổi lệnh cấp dưỡng con vì tôi bị mất việc.",
    "finder.ex2": "Có người quấy rối tôi tại nơi làm việc và tôi muốn có lệnh cấm tiếp xúc.",
    "finder.ex3": "Tôi muốn xác lập rằng tôi là cha của một đứa trẻ.",
    "finder.ex4": "Tôi cần nộp đơn kiện nhỏ về tiền thuê nhà chưa trả.",
    "finder.noMatch": "Không có kết quả phù hợp. Hãy thử mô tả tình huống của bạn theo cách khác, hoặc duyệt theo danh mục.",
    "finder.browseLibrary": "Duyệt thư viện",
    "finder.recommended": "Biểu mẫu được đề xuất",
    "finder.strong": "Rất phù hợp",
    "finder.likely": "Có thể phù hợp",
    "finder.possible": "Có khả năng phù hợp",
    "finder.preview": "Xem trước",
    "finder.startDraft": "Bắt đầu bản nháp",
    "finder.moreDetail": "Hãy mô tả tình huống của bạn chi tiết hơn một chút",
    "finder.noClose": "Không có kết quả gần đúng — hãy thử từ khác.",
    "finder.findFail": "Không thể tìm biểu mẫu",
    "finder.trialPrompt": "Bắt đầu dùng thử miễn phí hoặc nâng cấp để điền biểu mẫu",
    "finder.draftFail": "Không thể bắt đầu bản nháp",
    "detail.notFound": "Không tìm thấy biểu mẫu",
    "detail.backLibrary": "Quay lại thư viện",
    "detail.loading": "Đang tải…",
    "detail.formsLibrary": "Thư viện biểu mẫu",
    "detail.statute": "Điều luật:",
    "detail.whatsOn": "Nội dung biểu mẫu này · {count} trường",
    "detail.moreFields": "+ {count} trường nữa",
    "detail.loginTitle": "Đăng nhập để điền biểu mẫu này",
    "detail.loginDesc": "Tạo tài khoản miễn phí (dùng thử Pro 7 ngày) để hoàn thành biểu mẫu trực tuyến.",
    "detail.loginBtn": "Đăng nhập / Đăng ký",
    "detail.readyTitle": "Sẵn sàng để hoàn thành",
    "detail.readyDesc": "Điền biểu mẫu này theo từng trường với xem trước trực tiếp, rồi in hoặc tải xuống.",
    "detail.fillOnline": "Điền trực tuyến",
    "detail.downloadBlank": "Tải PDF trống",
    "detail.unlockTitle": "Mở khóa biểu mẫu này",
    "detail.unlockDesc": "Điền, lưu, hoàn thành bằng AI và tải xuống biểu mẫu này.",
    "detail.redirecting": "Đang chuyển hướng…",
    "detail.unlockBtn": "Mở khóa biểu mẫu này — $3.95",
    "detail.tryPreview": "Dùng thử miễn phí — điền & xem trước",
    "detail.or": "hoặc",
    "detail.goPro": "Nâng cấp Pro — biểu mẫu không giới hạn",
    "detail.downloadBlankFree": "Tải PDF trống (miễn phí)",
    "detail.fileConjunction": "Nộp kèm theo",
    "detail.oftenFiled": "Biểu mẫu thường được nộp cùng với {number}",
    "detail.adding": "Đang thêm…",
    "detail.addAll": "Thêm tất cả vào biểu mẫu của tôi",
    "detail.relatedDesc": "Những biểu mẫu này thường được hoàn thành cùng với biểu mẫu này. Hãy xem xét từng cái để biết tình huống của bạn có cần không.",
    "detail.goProToast": "Nâng cấp Pro để lưu biểu mẫu vào tài khoản của bạn",
    "detail.addedForms": "Đã thêm {count} biểu mẫu vào tài khoản của bạn",
    "detail.checkoutFail": "Không thể bắt đầu thanh toán",
    "footer.tagline": "Biểu mẫu của Ngành Tư pháp Bắc Carolina có thể điền, chỉnh sửa và in — sắp xếp theo danh mục và sẵn sàng hoàn thành trực tuyến.",
    "footer.product": "Sản phẩm",
    "footer.legalHead": "Pháp lý",
    "footer.terms": "Điều khoản & Điều kiện",
    "footer.privacy": "Chính sách bảo mật",
    "footer.eula": "Thỏa thuận người dùng cuối",
    "footer.disclaimer": "Không liên kết với Ngành Tư pháp Bắc Carolina. Không cung cấp tư vấn pháp lý.",
    "footer.rights": "Đã đăng ký bản quyền.",
  },
};
